import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {ScoresListHeaderModuleStatePopulationHandler} from "./scores-list-header-module.state-population.handler";
import {ScoresListHeaderModuleDateChangedEventHandler} from "./scores-list-header-module.date-changed-event-handler";
import {ToggleShowOddsHandler} from "../../../core/handlers/toggle-show-odds.handler";
import {ChangeOddsHandler} from "../../../core/handlers/change-odds.handler";
import {ScoresListHeaderModuleMobileDateClickHandler} from "./scores-list-header-module.mobile-date-click.handler";

export class ScoresListHeaderModuleHandlers extends HandlerList {

  static injectables = [
    ScoresListHeaderModuleStatePopulationHandler,
    ScoresListHeaderModuleDateChangedEventHandler,
    ScoresListHeaderModuleMobileDateClickHandler,
    ChangeOddsHandler,
    ToggleShowOddsHandler,
  ];

  constructor(
    scoresHeaderModuleLifecycleEventHandler: ScoresListHeaderModuleStatePopulationHandler,
    scoresHeaderModuleDateChangedEventHandler: ScoresListHeaderModuleDateChangedEventHandler,
    scoresListHeaderModuleMobileDateClickHandler: ScoresListHeaderModuleMobileDateClickHandler,
    scoresHeaderModuleChangeOddsHandler: ChangeOddsHandler,
    toggleShowOddsHandler: ToggleShowOddsHandler,
  ) {
    super();

    [
      scoresHeaderModuleLifecycleEventHandler,
      scoresHeaderModuleDateChangedEventHandler,
      scoresListHeaderModuleMobileDateClickHandler,
      scoresHeaderModuleChangeOddsHandler,
      toggleShowOddsHandler,
    ].forEach(handler => this.add(handler));
  }
}
